import {Component, inject, OnInit, Renderer2, signal, ViewChild} from '@angular/core';
import {TableComponent, TableOptions} from "@shared/components";
import {Version} from '@core/classes/tables/version';
import {NavigationEnd, Router} from '@angular/router';
import {APIService, DataService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {Subject, takeUntil} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';
import {
  VaccinationStatusActionComponent
} from '@modules/cy/patient/ps/components/vaccinations/actions/vaccination-status-action/vaccination-status-action.component';
import {
  AddVaccinationComponent
} from '@modules/cy/patient/ps/components/vaccinations/actions/add-vaccination/add-vaccination.component';
import {Allergy} from '@core/classes/tables/allergy';

@Component({
  selector: 'ncp-versions',
    imports: [
        TableComponent
    ],
  templateUrl: './versions.component.html',
  styleUrl: './versions.component.scss',
})
export class VersionsComponent implements OnInit {
  @ViewChild('versions') public versionsEl!: TableComponent<Version>;
  protected readonly router = inject(Router);
  protected apiService = inject(APIService);
  protected readonly dataService = inject(DataService);
  protected patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<Version>>(
    new TableOptions<Version>({
      id: 'versions',
      type: 'Versions',
      interface: Version,
      autoLoadData: false,
      data: this.dataService.getValueByKey('versions'),
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: this.dataService.getValueByKey('versions').length,
      },
      searchComponent: null,
      renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
        const data = row as Version;
        if (item === 'author') {
          td.innerHTML = data.author_name + ' ' + data.author_surname;
        }
      },
    })
  );

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }
}
